import React from "react";

import { Cell } from "..";

export interface ITableHead {
    name: string,
}

interface ITableProps {
    data: Array<string | number | {[key: string]: any}>,
    tableClassName?: string,
    head: Array<ITableHead>
}

const Table:React.FC<ITableProps> = ({
    data,
    tableClassName,
    head
}) => {

    const renderThead = (head: Array<ITableHead>) => {
        const jsx = head.map((item) => {
            return (
                <th key={item.name} className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left">
                    {item.name}
                </th>
            )
        })

        return jsx;
    }

    const renderTbody = (data: Array<string | number | {[key: string]: any}>) => {
        const jsx = data.map((item,i) => (
            <tr key={i}>
                {
                    typeof item === "object" ?
                        Object.keys(item).map((key) => {
                            return (
                                <Cell
                                    key={key}
                                    className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px text-left"
                                >
                                    {
                                        item[key as keyof typeof item]
                                    }
                                </Cell>
                            )
                        })
                    :
                    (
                        <Cell>
                            {item}
                        </Cell>
                    )
                }
            </tr>
            
        ))

        return jsx;
    }

    return (
        <>
            {
                data && data.length > 0
                    ?
                    <table className={`${tableClassName} table-auto w-full`}>
                        <thead className="text-xs font-semibold uppercase text-c-blue dark:text-c-gray bg-c-light-gray dark:bg-c-light-black border-t border-b border-c-gray dark:border-c-gray">
                        <tr>
                            {renderThead(head)}
                        </tr>
                        </thead>

                        <tbody className="text-sm divide-y divide-c-gray dark:divide-c-gray">
                        {renderTbody(data)}
                        </tbody>


                    </table>
                    :
                    <>
                        <table className={`${tableClassName} table-auto w-full`}>
                            <thead className="text-xs font-semibold uppercase text-c-blue dark:text-c-gray bg-c-light-gray dark:bg-c-light-black border-t border-b border-c-gray dark:border-c-gray">
                            <tr>
                                {renderThead(head)}
                            </tr>
                            </thead>
                        </table>
                        <div className="bg-c-light-gray dark:bg-c-light-black border-b border-l border-r border-c-gray dark:border-c-gray p-2 text-center dark:text-white">Нет данных</div>
                    </>
            }
        </>
    )

}

export default Table;